export default __webpack_public_path__ + "static/media/illustration-how_debt.a3b6a75f.png";